<template>
	<div class="page" data-name="select-regist">
		<f7-navbar>
			<f7-nav-left>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
			</f7-nav-left>
			<div class="title">
				회원가입 선택
			</div>
			<f7-nav-right>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
			</f7-nav-right>
    </f7-navbar>
		<div class="page-content">
			<div class="block-title">회원가입을 선택하세요.</div>
			<div class="list no-hairlines">
				<ul>
					<li class="margin"><button class="button button-outline" v-on:click="studentJoinCheck">학생 회원가입</button></li>				
					<li class="margin"><button class="button button-outline" v-on:click="parentJoinCheck">학부모 회원가입</button></li>
					<li class="agree-box">
						<div class="block age-check" style="display:none">
							<hr/>
							<div class="block-strong">만 14세 이상 입니까?</div>
							<div class="row">
								<button class="button button-round button-outline col" v-on:click="goStudentJoin">예</button>
								<button class="button button-round button-outline col" v-on:click="kidsAgreeCheck">아니오</button>
							</div>
						</div> 
						<div class="block kids-agree" style="display:none">
							<hr/>
							<div class="block-strong">정보통신망법에 따라 만14세 미만은 보호자 동의 및 보호자 본인인증 후에 회원가입이 진행됩니다. 동의 하십니까?</div>		
							<div class="row">
								<button class="button button-round button-outline col" v-on:click="getCertInfo('student')">동의</button>
								<button class="button button-round button-outline col" v-on:click="showAlert">미동의</button>
							</div>			
						</div>                             
						<div class="block parent-check" style="display:none">
							<hr/>
							<div class="block-strong">회원가입 및 중복회원 검사를 위해 본인 인증 후에 회원가입이 진행됩니다. 동의 하십니까?</div>		
							<div class="row">
								<button class="button button-round button-outline col" v-on:click="getCertInfo('parent')">동의</button>
								<button class="button button-round button-outline col" v-on:click="showAlert">미동의</button>
							</div>			
						</div>
					</li>
				</ul>
			</div>
		</div>

		<!--kmcert 인증 -->
		<div class="popup kmcert-view-popup" id="kmcert-view-popup" >
			<div class="view">
				<div class="page">
					<div class="navbar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner">
							<div class="title">인증</div>
							<div class="right">								
								<a class="link popup-close">닫기</a>
							</div>
						</div>
					</div>
					<div class="page-content kmcert-content" style="overflow-x:hidden;overflow-y:hidden;">	
						<div style="width:100%;height:100%;text-align:center" ref="tempDiv">	
						</div>						
					</div>
				</div>
			</div>
		</div>

		<form name="reqKMCISForm" method="post" ref="reqKMCISForm" >
    	<input type="hidden" name="tr_cert" ref="tr_cert"/>
    	<input type="hidden" name="tr_url" ref="tr_url"	/>
    	<input type="hidden" name="tr_add" ref="tr_add" />	  
			<input type="hidden" name="tr_close_use" ref="tr_close_use" />  
		</form>
	</div>
</template>

<script>
	import MODULE from '../../js/common/module.js'
	import Vue from 'vue';
	import { f7 } from 'framework7-vue';
	import CONST from '../../js/common/constant.js'
	import AUTH from '../../js/common/auth.js'
	import PAGES from '../../js/pages.js'
	import API from '../../js/common/api.js'

	export default {
		data() {
			return {
				userType: "",
				trCert: undefined,
				certNum:"",
				urlCode:"283001"	
			}
		},
		mounted() {   
			const _this = this;

			if(document.certResult == undefined) {
				document.certResult = function(code, data) {
					_this.setCertResult(code, data);
				}
			}		
		},
		methods: {

			setCertResult(resultCode, jsonData) {
				const _this = this;			
				var resultData = MODULE.Util.JsonStrToObject(jsonData);
				var certInfo = resultData.value.certInfo;

				if (resultCode == CONST.resultCode.OK) {
					MODULE.DialogBox.message("인증완료 되었습니다.");

					let param = {
						userName: certInfo.userName,
						mobile: certInfo.phoneNo,
						certNumber: certInfo.certNumber
					}

					var url = "";								
					if ("parent" == certInfo.userType) {
						url = PAGES.PARENT_REGIST_PAGE;
					} else {
						url = PAGES.REGIST_PAGE;
					}
					
					PAGES.goPage(url, param);										

				} else if (resultCode == CONST.resultCode.FAIL) {
					MODULE.DialogBox.message(certInfo.resultMessage);
				} else {
					MODULE.DialogBox.message("서버에 오류가 발생하였습니다.");
				}  
			
			},
			showAlert() {
				const _this = this;
				MODULE.DialogBox.message("동의를 하셔야 회원가입이 가능합니다.");
			},
			openKMCISWindow() {
				const _this = this;			
				
				if(MODULE.Util.isEmpty(_this.userType)) {
					MODULE.DialogBox.message("비정상 접근입니다.");
					return;
				}
				
				_this.$refs.tr_cert.value = _this.trCert;				
				_this.$refs.tr_url.value = API.getCertAuthResult()+"?certNum="+_this.certNum+"&userType="+_this.userType;								
				_this.$refs.tr_add.value = "N";  
				_this.$refs.tr_close_use.value = "N";			  	  
				
				window.name = "kmcisCertPopup";
				
				var KMCISWindow;
				var UserAgent = navigator.userAgent;

				/* 모바일 접근 체크
				// 모바일일 경우 (변동사항 있을경우 추가 필요)
				if (UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null 
					|| UserAgent.match(/LG|SAMSUNG|Samsung/) != null) {

					_this.$refs.reqKMCISForm.target = '';

				} else {
					KMCISWindow = window.open('', 'KMCISWindow', 'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );
   		
					if(KMCISWindow == null){
						var message = "※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는\n";
						message += "화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n";
						message += "※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.";

						MODULE.DialogBox.message(message);
						return;
					}

					_this.$refs.reqKMCISForm.target = 'KMCISWindow';
				}
				*/

				KMCISWindow = window.open('', 'KMCISWindow', 'width=460, height=570, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );
		
				if(KMCISWindow == null){
					var message = "브라우저의 팝업이 허용되어 있는지 확인해 주세요.";					
					MODULE.DialogBox.message(message);
					return;
				}

				_this.$refs.reqKMCISForm.target = 'KMCISWindow';
				 _this.$refs.reqKMCISForm.action = 'https://www.kmcert.com/kmcis/web/kmcisReq.jsp';
				//_this.$refs.reqKMCISForm.action = "https://dev.bj-sup.kr/dweb/all_guest/kmcert/cert/cert/certResultTest.page";
	  		_this.$refs.reqKMCISForm.submit();

				/* 이후에 팝업으로 오픈시 문제가 생기면 두개케이스 (앱: iframe, 웹: 팝업)으로 갈수도 있음 그래서 아래코드는 지우지 않음
				$(_this.$refs.tempDiv).html("");
				_this.$f7.popup.open("#kmcert-view-popup", true);
				var iframe = "<iframe src='about:blank'  width='397' height='693' scrolling='no' name='iframeKMCIS' ref='iframeKMCIS'></iframe>";
				$(_this.$refs.tempDiv).html(iframe);

				_this.$refs.reqKMCISForm.target = 'iframeKMCIS';
				_this.$refs.reqKMCISForm.action = "https://www.kmcert.com/kmcis/web/kmcisReq.jsp";				
				_this.$refs.reqKMCISForm.submit(); 
				*/
								
			},  
			getCertInfo(userType) {
				const _this = this;
							
				_this.userType = userType;					
				let param = {
					urlCode:_this.urlCode			
				};				
				
				API.jsonRequest({
					url: API.getCertInfo(),
					data: param
				}).then(function (data) {
					_this.trCert = data.trCert;
					_this.certNum = data.certNum;					
					_this.openKMCISWindow();
				}).catch(function (code){
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});

			},
			goStudentJoin() {
				const _this = this;
				let param = {}
				var url = PAGES.REGIST_PAGE;
				PAGES.goPage(url,param);
			},
			kidsAgreeCheck() {
				const _this = this;
				_this.initView();
				$(".kids-agree").show();

			},
			studentJoinCheck() {
				const _this = this;
				_this.initView();
				$(".age-check").show();				
			},
			parentJoinCheck() {
				const _this = this;
				_this.initView();
				$(".parent-check").show();
			},
			initView() {
				const _this = this;
				$(".agree-box .block").hide();				
			}

		}
	}
</script>